import { useState } from 'react'
import dayjs from 'dayjs'

import { Box } from '@dhl-ui/components'
import { EasySearchHitDto, EasySearchOverviewDto, EasySearchResultDto } from '@dhl/mdp-api'
import { PppOverview } from '~/modules/ppp/components/PppOverview'
import { PppHits } from '~/modules/ppp/components/PppHits'
import { PppDownloads } from './PppDownloads'

type Props = {
  result: EasySearchResultDto
  onlyErrors: boolean
  pid: string
}

const overviewSorter = (a: EasySearchOverviewDto, b: EasySearchOverviewDto) =>
  dayjs(a.addedTimestamp).diff(dayjs(b.addedTimestamp))
const hitsSorter = (a: EasySearchHitDto, b: EasySearchHitDto) => dayjs(a.timestamp).diff(dayjs(b.timestamp))

export const PppResultDisplay = ({ result, onlyErrors, pid }: Props) => {
  const { overview = [], hits = [] } = result
  const correlationId = hits[0]?.correlationId
  const [selectedCorrelationId, setSelectedCorrelationId] = useState<string>(correlationId ?? '')
  const hasCorrectCorrelationId = (hit: EasySearchHitDto) => hit.correlationId === selectedCorrelationId
  const sortedHits = hits.filter(hasCorrectCorrelationId).sort(hitsSorter)

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <PppOverview
          overview={overview.sort(overviewSorter)}
          hits={hits}
          onSelectRow={setSelectedCorrelationId}
          correlationId={selectedCorrelationId}
          onlyErrors={onlyErrors}
        />
      </Box>
      {result?.hits && (
        <>
          <Box sx={{ mt: 2 }}>
            <PppDownloads hits={sortedHits} />
          </Box>

          <Box sx={{ mt: 2 }}>
            <PppHits hits={sortedHits} onlyErrors={onlyErrors} pid={pid} />
          </Box>
        </>
      )}
    </>
  )
}
